module.exports = __webpack_public_path__ + "img/info.21698e06.svg";